import React from 'react';
import { SearchBar } from '../Search';
import { Text } from '@chakra-ui/react';

const Header = ({ setFilteredText, headingText, subHeadingText }) => {
  return (
    <>
      <Text fontSize="34px" color="#1b254b" fontWeight="700">
        {headingText}
      </Text>
      <SearchBar mt="8px" maxWidth="300px" setFilteredText={setFilteredText} />

      <Text
        color="var(--chakra-colors-gray-500)"
        fontWeight="700"
        fontSize="1rem"
        textAlign="center"
        pt="20px"
      >
        {subHeadingText}
      </Text>
    </>
  );
};

export default Header;
